export default {
  permissionStatus: {
    pending: 'PENDING',
    active: 'ACTIVE',
    sunset: 'SUNSET',
  },
  accountStatus: {
    pending: 'ACTIVE',
    active: 'INACTIVE',
    sunset: 'CLOSED',
  },
  userCategory: {
    agent: 'AGENT',
    customer: 'CUSTOMER',
  },
};
